export default "/images/vendor/flag-icon-css/flags/1x1/tl.svg?d8e3bbb05aa228ef7591ec6b2a9b5154";